import { ClipLoader } from 'react-spinners'
import { useGetAnalysisOverview, useGetStakingAnalysisOverview } from '../../../core/services/react-query/analysis'
import { getMainTheme } from '../../../core/utils/theme'
import AnalysisDateSelect from './AnalysisDateSelect'
import Text from '../../../core/utils/Text'
import { formatNumber } from '../../../core/utils/common'
import { useAnalysisDateParams } from './analysisDateParams'

const StakingAnalysisOverview = ({ flow }) => {
	const { params, date, setDate, customDates, setCustomDates, dates } = useAnalysisDateParams()

	const { data: stakingData, isLoading: stakingDataLoading } = useGetStakingAnalysisOverview({ params, })
	console.log(stakingData);

	return (
		<div>
			<AnalysisDateSelect
				value={date}
				onChange={setDate}
				options={dates}
				customDates={customDates}
				onCustomChange={setCustomDates}
			/>
			<div
				className={`
			rounded-md bg-gray-100 dark:bg-mainBg py-3 px-5 shadow-md w-full
			border-[1px] border-slate-500 border-opacity-30 relative h-[180px]
				`}
			>
				{stakingDataLoading ? (
					<div className={'absolute left-0 top-0 w-full h-full flex items-center justify-center'}>
						<ClipLoader color={getMainTheme().active} size={20} />
					</div>
				) : null}

				<div className={'overflow-x-auto pb-2 h-full w-full flex items-center gap-5'}>
					{stakingData?.map((item) => {
						return <Item item={item} key={item._id} />
					})}
				</div>
			</div>
		</div>
	)
}

const Item = ({ item, ...rest }) => {
	return (
		<div
			{...rest}
			className={`rounded-lg bg-white dark:bg-cardBg
                    h-full min-w-[300px] shadow flex items-center justify-center
                    dark:text-gray-300 px-5 py-3 text-sm
                `}
		>
			<div className={'flex w-full flex-col items-center gap-2'}>
				<div className={'flex items-center gap-1 w-full justify-between'}>
					<div className={'flex items-center gap-2'}>
						<div className={'dark:bg-gray-300 bg-gray-700 rounded w-[12px] h-[12px]'} />
						<span className={'mt-1'}>{item.currency.toUpperCase()}</span>
					</div>
					<div className={'px-6 rounded dark:bg-gray-200 bg-slate-700'}>
						<p className={'text-xs dark:text-slate-700 text-gray-200'} >{item?.status}</p>
					</div>
				</div>
				<div className={'w-full flex items-center justify-between mt-3'}>
					<Text tid={'staking-amount'} className={'text-gray-500 text-xs'} />
					<span>{formatNumber(item.amount, { type: item.currency })}</span>
				</div>
				<div className={'w-full flex items-center justify-between'}>
					<Text tid={'staking-amountPaid'} className={'text-gray-500 text-xs'} />
					<span>{formatNumber(item.amountPaid, { type: item.currency })}</span>
				</div>
				<div className={'w-full flex items-center justify-between'}>
					<Text tid={'staking-count'} className={'text-gray-500 text-xs'} />
					<span>{item.count}</span>
				</div>
			</div>
		</div>
	)
}

export default StakingAnalysisOverview
